module.exports = "/_next/static/images/logo_main-dark-alt-4d3e4ff6c8219d6c7a6a1b9f2fe580c0.png";